function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import PropTypes from "prop-types";

var SvgAcademia = function SvgAcademia(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M20.016 13.453V7.326c0-1.011.833-1.826 1.855-1.826h1.806c1.022 0 1.855.815 1.855 1.826v.825h1.307c1.022 0 1.855.815 1.855 1.826v6.57h.806V14.45a.5.5 0 01.048-.998c.523 0 .952.42.952.942v2.21a.947.947 0 01-.952.942h-.854v3.476c0 1.011-.833 1.826-1.855 1.826h-1.307v.825c0 1.011-.833 1.826-1.855 1.826h-1.806c-1.022 0-1.855-.815-1.855-1.826v-6.127h-8.032v6.127c0 1.011-.833 1.826-1.855 1.826H8.323c-1.022 0-1.855-.815-1.855-1.826v-.825H5.16c-1.022 0-1.855-.815-1.855-1.826v-3.476h-.854a.947.947 0 01-.952-.942v-2.21c0-.523.429-.942.952-.942a.5.5 0 01.048.998v2.096h.806v-6.57c0-1.011.833-1.826 1.855-1.826h1.307v-.825c0-1.011.833-1.826 1.855-1.826h1.806c1.022 0 1.855.815 1.855 1.826v9.22h8.032v-2.093h-6.274a.5.5 0 010-1h6.274zm4.516 8.896V7.326c0-.454-.38-.826-.855-.826h-1.806c-.475 0-.855.372-.855.826v16.348c0 .454.38.826.855.826h1.806c.475 0 .855-.372.855-.826V22.35zm1-.5h1.307c.474 0 .855-.372.855-.826V9.977c0-.454-.38-.826-.855-.826h-1.307V21.85zM7.468 8.65v15.023c0 .454.38.826.855.826h1.806c.475 0 .855-.372.855-.826V7.326c0-.454-.38-.826-.855-.826H8.323c-.475 0-.855.372-.855.826V8.65zm-1 .5H5.16c-.474 0-.855.372-.855.826v11.046c0 .454.38.826.855.826h1.307V9.15z"
  }));
};

SvgAcademia.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgAcademia.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgAcademia;